import React from 'react';

import { Box, Button, Shimmer } from '@betterment/samba-react';

import { BorderedBox } from './BorderedBox';
import { Disclaimer } from './Disclaimer';
import { SaleDetailsRow } from './SaleDetailsRow';
import { separatorStyles } from './styles';

export const SellOrderFormLoading: React.FC = () => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', rowGap: 'space.300' }}>
      <BorderedBox css={{ '& > *': separatorStyles }}>
        <SaleDetailsRow>
          <SaleDetailsRow.Label>
            <Shimmer data-testid="account-label-shimmer" css={{ height: 'size.300', width: '125px' }} />
          </SaleDetailsRow.Label>
          <SaleDetailsRow.Value>
            <Shimmer data-testid="account-display-name-shimmer" css={{ height: 'size.300', width: '240px' }} />
          </SaleDetailsRow.Value>
        </SaleDetailsRow>

        <SaleDetailsRow>
          <SaleDetailsRow.Label>
            <Shimmer data-testid="asset-label-shimmer" css={{ height: 'size.300', width: '125px' }} />
          </SaleDetailsRow.Label>
          <SaleDetailsRow.Value>
            <Shimmer data-testid="asset-data-shimmer" css={{ height: 'size.300', width: '240px' }} />
          </SaleDetailsRow.Value>
        </SaleDetailsRow>

        <SaleDetailsRow>
          <SaleDetailsRow.Label>
            <Shimmer data-testid="available-to-sell-label-shimmer" css={{ height: 'size.300', width: '125px' }} />
          </SaleDetailsRow.Label>
          <SaleDetailsRow.Value>
            <Shimmer data-testid="available-to-sell-data-shimmer" css={{ height: 'size.300', width: '240px' }} />
          </SaleDetailsRow.Value>
        </SaleDetailsRow>
      </BorderedBox>

      <BorderedBox css={{ display: 'flex', flexDirection: 'column', rowGap: 'space.300', paddingY: 'space.300' }}>
        <Box css={{ display: 'flex', columnGap: 'space.100', alignItems: 'flex-end' }}>
          <Box css={{ flex: 1 }}>
            <Shimmer data-testid="amount-to-sell-shimmer" css={{ height: 'size.600' }} />
          </Box>
          <Box css={{ minWidth: '150px' }}>
            <Shimmer data-testid="sell-order-units-shimmer" css={{ height: 'size.600' }} />
          </Box>
        </Box>
        <Disclaimer />
      </BorderedBox>

      <Box>
        <Button variant="solidPrimary" type="submit" disabled={true}>
          Review order
        </Button>
      </Box>
    </Box>
  );
};
